import { defaultBscProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/bsc/default-constants';

export const PANCAKE_SWAP_CONTRACT_ADDRESS = '0x10ED43C718714eb63d5aA57B78B54704E256024E';

export const PANCAKE_SWAP_PROVIDER_CONFIGURATION = defaultBscProviderConfiguration;
